const getChannelFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('channel') || 'seo_top'
}

export const API = {
    ENDPOINTS: {
        CITIES: '/api/v1/cities/search.json',
        SIGNUP: `/signup?channel=${getChannelFromUrl()}`,
    },
    HEADERS: {
        CONTENT_TYPE: 'application/json',
    },
} as const
